/*eslint-disable */

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import "../../_components/antd.css";
import { Table } from "antd";
import Data from "../../assets/jsons/payments";
import FeatherIcon from "feather-icons-react";
import { onShowSizeChange } from "../../_components/paginationfunction";
import Select from "react-select";

const Payments = () => {
  const [menu, setMenu] = useState(false);
  const company = window.COMPANY;
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteID, setDeleteID] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  useEffect(() => {
    fetchPayments();
    fetchCustomers();
  }, []);

  useEffect(() => {
    fetchPayments(selectedCustomer?.value || null);
  }, [selectedCustomer]);

  const fetchPayments = async (customerId = null) => {
    try {
      setLoading(true);
      let url = "/payments/api/";
      if (customerId) {
        url += `?customer=${customerId}`;
      }
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setPayments(data);
    } catch (error) {
      console.error("Error fetching payments:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await fetch("/customers/list/");
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setCustomers(data);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const customerOptions = [
    { value: null, label: "All Customers" },
    ...customers.map((customer) => ({
      value: customer.id,
      label: customer.user.full_name,
    })),
  ];

  const datasource = Data?.Data;

  const columns = [
    {
      title: "#Payment Number",
      dataIndex: "payment_number",
      render: (text, record) => (
        <Link to={`/payments/${record.id}/edit-payment`}>
          {record.payment_number}
        </Link>
      ),
    },
    {
      title: "Customer",
      dataIndex: "Name",
      render: (img, record) => (
        <>
          <h2 className="table-avatar">{record.customer.user.full_name}</h2>
        </>
      ),
    },
    {
      title: "Invoice",
      dataIndex: "invoice",
      render: (text, record) =>
        record.invoice ? (
          <a href={`/invoice/${record.invoice.id}/invoice`}>
            {record.invoice.invoice_number}
          </a>
        ) : (
          <span>-</span>
        ),
    },
    {
      title: "Amount Received",
      dataIndex: "amount_received",
      render: (text) => (
        <span className="text-nowrap">
          {company?.currency_symbol} {parseFloat(text).toFixed(2)}
        </span>
      ),
      sorter: (a, b) => a.amount_received - b.amount_received,
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      render: (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, "0");
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const month = monthNames[d.getMonth()];
        const year = d.getFullYear();
        return <span>{`${day} ${month} ${year}`}</span>;
      },
      sorter: (a, b) => new Date(a.payment_date) - new Date(b.payment_date),
      defaultSortOrder: "descend",
    },
    {
      title: "Payment Type",
      dataIndex: "payment_type",
      render: (text) => (
        <span
          className="text-nowrap"
          style={{
            textTransform: "capitalize",
          }}
        >
          {text || "-"}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "Action",
      render: (d, r) => (
        <>
          <div className="d-flex align-items-center">
            {r?.attachment && (
              <Link
                className=" btn-action-icon me-2"
                to={r?.attachment}
                download=""
              >
                <FeatherIcon icon="download" />
              </Link>
            )}

            <Link
              className="btn-action-icon me-2"
              to={`/payments/${r.id}/edit-payment`}
            >
              <FeatherIcon icon="eye" />
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_modal"
              onClick={() => {
                setDeleteID(r.id);
              }}
            >
              <i className="far fa-trash-alt me-3" />
            </Link>
          </div>
        </>
      ),
    },
  ];

  const [analytics, setAnalytics] = useState(null);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const response = await fetch("/payments/api/analytics/");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setAnalytics(data);
      } catch (error) {
        console.error("Error fetching analytics:", error);
      }
    };
    fetchAnalytics();
  }, []);
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="row mb-0">
              <div className="col-md-3 col-sm-6 mb-3">
                <div className="card shadow-sm border-0">
                  <div className="card-body d-flex align-items-center">
                    <div className="me-3">
                      <FeatherIcon
                        icon="dollar-sign"
                        size={32}
                        className="text-warning"
                      />
                    </div>
                    <div>
                      <h6 className="mb-1" style={{ color: "green" }}>
                        Total Funds
                      </h6>
                      <h4 className="mb-0 fw-bold" style={{ color: "green" }}>
                        {company?.currency_symbol} {analytics?.total_funds}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 mb-3">
                <div className="card shadow-sm border-0">
                  <div className="card-body d-flex align-items-center">
                    <div className="me-3">
                      <FeatherIcon
                        icon="credit-card"
                        size={32}
                        className="text-primary"
                      />
                    </div>
                    <div>
                      <h6 className="mb-1">Total Payment</h6>
                      <h4 className="mb-0 fw-bold">
                        {company?.currency_symbol} {analytics?.total_payments}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 mb-3">
                <div className="card shadow-sm border-0">
                  <div className="card-body d-flex align-items-center">
                    <div className="me-3">
                      <FeatherIcon
                        icon="arrow-up-circle"
                        size={32}
                        className="text-success"
                      />
                    </div>
                    <div>
                      <h6 className="mb-1">Advance Payments</h6>
                      <h4 className="mb-0 fw-bold">
                        {company?.currency_symbol} {analytics?.advance_payments}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-6 mb-3">
                <div className="card shadow-sm border-0">
                  <div className="card-body d-flex align-items-center">
                    <div className="me-3">
                      <FeatherIcon
                        icon="trending-down"
                        size={32}
                        className="text-danger"
                      />
                    </div>
                    <div>
                      <h6 className="mb-1" style={{ color: "red" }}>
                        Expenses
                      </h6>
                      <h4 className="mb-0 fw-bold" style={{ color: "red" }}>
                        {company?.currency_symbol} {analytics?.total_expenses}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-header">
              <div className="content-page-header">
                <h5>Accounts</h5>
                <div className="list-btn d-flex align-items-center gap-4">
                  <div className="input-block">
                    <Select
                      value={selectedCustomer}
                      onChange={setSelectedCustomer}
                      options={customerOptions}
                      placeholder="All Customers"
                      isClearable={false}
                      styles={{
                        control: (base) => ({
                          ...base,
                          width: "200px",
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                        option: (base) => ({
                          ...base,
                          cursor: "pointer",
                        }),
                      }}
                    />
                  </div>
                  <div className="text-end">
                    <a
                      href="/payments/add-payment"
                      type="submit"
                      className="btn btn-primary"
                    >
                      Records Payments
                    </a>
                  </div>

                </div>
              </div>
            </div>
            {/* /Page Header */}

            {/* Customer Filter */}

            {/* /Customer Filter */}

            {/* Table */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card-table">
                  <div className="card-body payments">
                    <div className="table-responsive table-hover">
                      <Table
                        loading={loading}
                        pagination={{
                          total: payments?.length,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          // showSizeChanger: true,
                          onShowSizeChange: onShowSizeChange,
                        }}
                        columns={columns}
                        dataSource={payments || []}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Table */}
          </div>
        </div>

        <div
          className="modal custom-modal fade"
          id="delete_modal"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content">
              <div className="modal-body">
                <div className="form-header">
                  <h3>Delete Payments</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div className="modal-btn delete-action">
                  <div className="row">
                    <div className="col-6">
                      <button
                        type="reset"
                        data-bs-dismiss="modal"
                        className="w-100 btn btn-primary paid-continue-btn"
                        onClick={async () => {
                          if (!deleteID) return;
                          try {
                            await fetch(`/payments/api/${deleteID}/`, {
                              method: "DELETE",
                              headers: {
                                "X-CSRFToken": document.cookie
                                  .split("; ")
                                  .find((row) => row.startsWith("csrftoken="))
                                  ?.split("=")[1],
                              },
                            });
                            // Optionally, refresh payments list
                            setPayments((prev) =>
                              prev.filter((p) => p.id !== deleteID)
                            );
                            window.location.reload();
                          } catch (err) {
                            console.error("Delete failed", err);
                          }
                          setDeleteID(null);
                        }}
                      >
                        Delete
                      </button>
                    </div>
                    <div className="col-6">
                      <button
                        type="submit"
                        data-bs-dismiss="modal"
                        className="w-100 btn btn-primary paid-cancel-btn"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Payments;
